import React, { memo, useMemo } from 'react';
import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  Tooltip,
  Label,
  ResponsiveContainer,
} from 'recharts';
import { useHistory, useLocation } from 'react-router-dom';
import { chartColor } from '../provider';
import { getSignalStrengthData } from './provider';
import { ChartProps } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  pullRight: {
    textAlign: 'right',
  },
  wrapper: {
    display: 'block',
    padding: theme.spacing(2),
  },
  secondRowWidgets: {
    height: '75px',
    minHeight: '75px',
  },
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

function SignalStrengthPieChart({
  reports = [],
  disabledClick = false,
  avg = false,
}: ChartProps) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const signalStrengthData = useMemo(
    () => getSignalStrengthData(reports, avg),
    [reports, avg]
  );

  const chartData = signalStrengthData.chartData.filter((d) => !!d.val);
  const renderLabel = () => {
    return (
      <g>
        <foreignObject width="130" height="80" x={65} y={120}>
          <Typography variant="body2" color="textSecondary" align="center">
            {`Available for`}
            <br />
            {`${signalStrengthData.totalCount} device${
              signalStrengthData.totalCount === 1 ? '' : 's'
            }`}
          </Typography>
        </foreignObject>
      </g>
    );
  };

  return (
    <Paper className={classes.wrapper}>
      <Typography variant="h6" align="left">
        Signal Strength
        {avg && <> Average</>}
      </Typography>
      <ResponsiveContainer
        height={320}
        width={260}
        className={classes.container}
      >
        <PieChart>
          <Pie
            data={chartData}
            dataKey="val"
            isAnimationActive={true}
            innerRadius={90}
            outerRadius={110}
            paddingAngle={1.5}
          >
            {chartData.map((cat) => (
              // @ts-ignore
              <Cell
                stroke="transparent"
                key={cat.name}
                fill={chartColor(cat.key)}
                cursor="pointer"
                onClick={() => {
                  if (disabledClick) return;
                  history.push(
                    `/devices${location.search ? location.search + '&' : '?'}${
                      avg
                        ? 'signal_strength_average_health'
                        : 'signal_strength_health'
                    }=${cat.name.toLowerCase()}`
                  );
                }}
              />
            ))}
            <Label content={renderLabel} />
          </Pie>
          <Tooltip />
          <Legend key="label" />
        </PieChart>
      </ResponsiveContainer>
    </Paper>
  );
}

export default memo(SignalStrengthPieChart);
